import React from "react";
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import OruclicksLogo from "../../Reusable/Logo";

const ResponsiveAppBar = ({ isDarkTheme }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  return (
    <AppBar
      className="customize_header"
      position="fixed"
      elevation={0}
      sx={{
        background: isDarkTheme
          ? "linear-gradient(to right, #1a237e, #000000)"
          : "linear-gradient(to right, #ffffff, #f5f7fa)",
        color: isDarkTheme ? "#fff" : "#000",
        fontFamily: "DM Sans",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "0 0 15px 15px",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transform: "translate3d(0, 0, 0)",
        WebkitTransform: "translate3d(0, 0, 0)",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        transition: "none",
      }}
    >
      <Container>
        <Toolbar
          disableGutters
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "nowrap",
            py: isMobile ? 0.25 : 0.5,
          }}
        >
            {/* Logo - Left Side */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              <OruclicksLogo
                isDarkTheme={isDarkTheme}
                onClick={handleLogoClick}
                showText={true}
                size={isMobile ? "42px" : "45px"}
                textSize={isMobile ? "22px" : "24px"}
                iconOnly={false}
              />
            </Box>

          </Toolbar>
        </Container>
      </AppBar>
  );
};

export default ResponsiveAppBar;
